import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Component({
    selector: 'app-contact',

    standalone: true,

    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule
    ],

    templateUrl: './contact.html',

    styleUrl: './contact.scss'
})
export class Contact {

    form = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    };


    selectedFile: File | null = null;


    sending = false;

    sent = false;

    error = false;

    errorMessage = '';


    constructor(
        private http: HttpClient
    ) {}


    // ============================
    // FILE
    // ============================

    onFileSelected(event: Event): void {

        const input =
            event.target as HTMLInputElement;


        if (
            !input.files ||
            input.files.length === 0
        ) {

            this.selectedFile = null;

            return;
        }


        const file =
            input.files[0];


        // MAX 20 MB

        if (
            file.size >
            20 * 1024 * 1024
        ) {

            this.selectedFile = null;

            input.value = '';

            this.error = true;

            this.errorMessage =
                'Fajl ne može biti veći od 20 MB.';

            return;
        }


        // DOZVOLJENI FORMAT

        const allowedExtensions = [
            'pdf',
            'ai',
            'psd',
            'png',
            'jpg',
            'jpeg'
        ];


        const extension =
            file.name
                .split('.')
                .pop()
                ?.toLowerCase();


        if (
            !extension ||
            !allowedExtensions.includes(extension)
        ) {

            this.selectedFile = null;

            input.value = '';

            this.error = true;

            this.errorMessage =
                'Dozvoljeni formati su PDF, AI, PSD, PNG i JPG.';

            return;
        }


        this.error = false;

        this.errorMessage = '';

        this.selectedFile = file;
    }


    // ============================
    // SEND
    // ============================

    sendMessage(): void {

        this.sending = true;

        this.sent = false;

        this.error = false;

        this.errorMessage = '';


        const formData =
            new FormData();


        // TEXT

        formData.append(
            'name',
            this.form.name
        );


        formData.append(
            'email',
            this.form.email
        );


        formData.append(
            'phone',
            this.form.phone
        );


        formData.append(
            'subject',
            this.form.subject
        );


        formData.append(
            'message',
            this.form.message
        );


        // FILE - OPCION

        if (this.selectedFile) {

            formData.append(
                'file',
                this.selectedFile,
                this.selectedFile.name
            );

        }


        // ============================
        // PHP
        // ============================

        this.http.post(
            'https://lazzaro.rs/contact.php',
            formData
        )
        .subscribe({

            next: (response: any) => {

                console.log(
                    'CONTACT SUCCESS:',
                    response
                );


                this.sending = false;

                this.sent = true;

                this.error = false;


                // RESET FORME

                this.form = {

                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''

                };


                this.selectedFile = null;


                // Reset file input

                const fileInput =
                    document.getElementById(
                        'file-upload'
                    ) as HTMLInputElement | null;


                if (fileInput) {

                    fileInput.value = '';

                }

            },


            error: (err) => {

                console.error(
                    'CONTACT ERROR:',
                    err
                );


                this.sending = false;

                this.sent = false;

                this.error = true;


                if (
                    err?.error?.message
                ) {

                    this.errorMessage =
                        err.error.message;

                } else {

                    this.errorMessage =
                        'Došlo je do greške prilikom slanja poruke.';

                }

            }

        });

    }

}